export const CartBlockedDatesKcal = (json: ICartBlockedDatesKcal): ICartBlockedDatesKcalModel => {
	const { blocked_dates, ...rest } = json
	return {
		blockedDates: blocked_dates ?? [],
		...toCamelCase(rest),
	}
}

export const CartBlockedDates = (json: ICartBlockedDates): ICartBlockedDatesModel => {
	const { kcals, ...rest } = json
	return {
		kcals: convertArrayModel(kcals, CartBlockedDatesKcal),
		...toCamelCase(rest),
	}
}
